<template>
  <div class="card">
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <hr>
    <div class="card-body">
      <slot></slot>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <hr>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'card'
  }
</script>
<style>
  .arr-right .breadcrumb-item+.breadcrumb-item::before {
  
    content: "›";
 
    vertical-align:top;
 
    color: #ccc;
 
    font-size:35px;
 
    line-height:18px;
 
  }

   .table > thead > tr > th {
     border-bottom-width: 1px;
     font-size: 15px !important;
     text-transform: none !important;
     color: #666;
     font-weight: 400;
     padding-bottom: 5px;
     border-top: none !important;
     border-bottom: none;
     text-align: left !important;
 }

 
 .card label{
      font-size: 16px;
      margin-bottom: 0px;
      text-transform: none;
      color: #000;
  }

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/Card.vue